import React from 'react'
import { Modal, Button, Input } from 'react-bootstrap'
import VInput from './input'
import ReactMixin from 'react-mixin'
import ImmutableRenderMixin from 'react-immutable-render-mixin'
import createLinkToImmutable from '_/utils/createLinkToImmutable'
import getTransactionType from '_/utils/getTransactionType'

/**
 * Bottom navigation component
 */
@ReactMixin.decorate(ImmutableRenderMixin)
class ExhibitModal extends React.Component {
  static propTypes = {
    show: React.PropTypes.bool,
    transaction: React.PropTypes.object.isRequired,
    exhibit: React.PropTypes.object.isRequired,
    exhibitTypes: React.PropTypes.array.isRequired,
    onAdd: React.PropTypes.func.isRequired,
    onChange: React.PropTypes.func.isRequired,
    onRemove: React.PropTypes.func.isRequired,
    onHide: React.PropTypes.func
  }

  static contextTypes = {
    store: React.PropTypes.object
  }

  constructor(props, context) {
    super(props, context)
    this.state = {
      isNew: !props.exhibit.has('id'),
      exhibit: props.exhibit,
      link: createLinkToImmutable(this, 'exhibit')
    }
  }

  componentWillReceiveProps (props) {
    this.state = {
      isNew: !props.exhibit.has('id'),
      exhibit: props.exhibit,
      link: createLinkToImmutable(this, 'exhibit')
    }
  }

  async handleExhibit (evt) {
    evt.preventDefault()
    const { transaction, onAdd, onChange } = this.props
    const { exhibit, isNew } = this.state
    const { store } = this.context
    const file = isNew && this.refs.file.getInputDOMNode().files[0]
    const type = getTransactionType(transaction) + 's'

    try {
      if (isNew) {
        this.setState({ disableSubmit: true })
        const newExhibit = await store.post(`/${type}/${transaction.get('id')}/exhibits`,
          exhibit.set('filename', file.name)
        )
        const updateExhibit = await store.put(`/${type}/${transaction.get('id')}/exhibits/${newExhibit.get('id')}`, file)
        onAdd(updateExhibit)
      }
      else {
        const updateExhibit = await store.post(`/${type}/${transaction.get('id')}/exhibits/${exhibit.get('id')}`, exhibit)
        onChange(updateExhibit)
      }
    } catch (er) {
      this.setState({
        errors: er.response.body.details
      })
    }

    this.setState({ disableSubmit: false })
  }

  async handleDelete (evt) {
    evt.preventDefault()
    const { transaction, onRemove } = this.props
    const { exhibit } = this.state
    const { store } = this.context
    const type = getTransactionType(transaction) + 's'

    try {
      await store.delete(`/${type}/${transaction.get('id')}/exhibits/${exhibit.get('id')}`)
      onRemove(exhibit)
    } catch (er) {
      console.error(er)
      this.setState({
        errors: er.response.body.details
      })
    }
  }

  render () {
    const { exhibitTypes, show, onHide } = this.props
    const { link, isNew, disableSubmit } = this.state

    return (
      <Modal show={show} onHide={onHide}>
        <Modal.Header closeButton>
          <h3 className="modal-title">{isNew ? 'New' : 'Edit'} exhibit</h3>
        </Modal.Header>

        <Modal.Body>
          <VInput
            label="Type"
            type="select"
            valueLink={link('type')}
            options={exhibitTypes.map(d => {
              return { value: d, label: d }
            })}
            name="type" />

          <VInput
            label="Description"
            type="textarea"
            valueLink={link('description')}
            name="description" />

          {isNew &&
            <Input
              label="File"
              type="file"
              name="file"
              ref="file"
              help="Select or drag a file of the type specified above. Video and audio files must be processed after upload before viewing, processing time will vary based on the size of the file." />
          }

          <div className="pull-right">
            {!isNew &&
              <Button
                type="button"
                bsStyle="danger"
                onClick={::this.handleDelete}>
                Delete
              </Button>
            }
          </div>
          <Button
            type="submit"
            disabled={disableSubmit}
            bsStyle="info"
            onClick={::this.handleExhibit}>
            {isNew ? 'Create' : 'Update'} exhibit
          </Button>
        </Modal.Body>
      </Modal>
    )
  }
}

export default ExhibitModal



// WEBPACK FOOTER //
// ./modules/shared/components/editExhibitModal.js